// src/components/Resume/ResumeDownload.jsx
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Download } from 'lucide-react';
import { Button } from 'react-bootstrap';
import toast from 'react-hot-toast';

const ResumeDownload = ({ 
  resumeId, 
  formData, 
  industry, 
  coverLetterData, 
  activeTab,
  sections = []
}) => {
  const { user, profile } = useAuth();
  const [loading, setLoading] = useState(false);

  const isPremium = profile?.subscription_tier === 'premium' && 
                    new Date(profile?.subscription_expires_at) > new Date();

  const handleDownload = async () => {
    setLoading(true);
    try {
      const { pdf } = await import('@react-pdf/renderer');
      const { default: ResumePDF } = await import('./ResumePDF');
      
      const pdfData = {
        ...formData,
        certifications: formData.certifications || [],
      };

      const blob = await pdf(
        <ResumePDF 
          data={pdfData} 
          industry={industry} 
          coverLetterData={coverLetterData}
          activeTab={activeTab}
          formData={formData}
          sections={sections}
        />
      ).toBlob();
      
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      
      const fileName = activeTab === 'cover-letter' 
        ? `${formData.full_name || 'cover-letter'}_CoverLetter_${new Date().toISOString().split('T')[0]}.pdf`
        : `${formData.full_name || 'resume'}_${industry || 'general'}.pdf`;
      
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      toast.success(`✅ ${activeTab === 'cover-letter' ? 'Cover Letter' : 'Resume'} downloaded successfully!`);
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download. Please try again.');
    }
    setLoading(false);
  };

  return (
    <Button
      onClick={handleDownload}
      disabled={loading}
      className="btn-hero-primary d-flex align-items-center gap-2 px-4 py-2"
    >
      <Download size={18} />
      <span>
        {loading 
          ? 'Generating...' 
          : activeTab === 'cover-letter' 
            ? 'Download Cover Letter' 
            : 'Download PDF'
        }
      </span>
    </Button>
  );
};

export default ResumeDownload;